module.exports = __webpack_public_path__ + "static/media/power_icon.08cddb13.png";